import styled from "styled-components";

const Container = styled.div`
  background-color: black;
  display: flex;
  flex-direction: row;
  flex-grow: 1;
  align-items: center;
  &:hover {
    cursor: pointer;
  }
  gap: var(--Spacing-075, 12px);
`;

const LogoImg = styled.img`
  margin: 0px 0px 0px 16px;
  display: block;
`;

const AppTitle = styled.div`
  color: var(--Text-Base-Reversed, #FFF);
  font-family: "Source Sans Pro";
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: 24px;
  letter-spacing: -0.04px;
`;

export { Container, LogoImg, AppTitle };
